import { getIconByContentType, getLessonItemImageCover, getLessonItemType } from 'core/utils/lessonItems';
import { isImage } from 'core/utils/utils';
import { CLIENT } from 'core/variables/constant';

export function validateLessonItemsItem(lessonItem) {
  const didacticType = lessonItem?.didactic_types?.length > 0 ? lessonItem?.didactic_types[0] : null;

  return {
    ...lessonItem,
    guid: lessonItem?.lesson_item_guid,
    icon: didacticType?.icon && isImage(didacticType.icon) ? didacticType.icon : getIconByContentType(lessonItem?.content_type),
    image: getLessonItemImageCover(lessonItem?.content_type, lessonItem?.delivered_at, lessonItem?.can_deliver_late),
    didacticTypeCover: didacticType?.thumbnail ? didacticType.thumbnail : null,
    // NOTE: `type` stays conflated (didactic name OR content-format name) on purpose — it's
    // used for UI display elsewhere. didacticTypeName below is the non-conflated
    // equivalent, added for TAN-9876's analytics enrichment (content_type itself is
    // derived centrally from content_type_guid by enrichOpenContentProperties).
    type: didacticType?.name ? didacticType.name : getLessonItemType(lessonItem?.content_type),
    didacticTypeName: didacticType?.name ?? null,
    content_name: lessonItem?.content_name ?? lessonItem?.name,
    contentType: lessonItem?.content_type,
    isEvaluable: lessonItem?.content_is_evaluable,
    deliveredAt: lessonItem?.delivered_at,
    canDeliverLate: lessonItem?.can_deliver_late,
    evaluatedBy: lessonItem?.evaluated_by,
    jobStatus: lessonItem?.status || lessonItem?.job_status,
    thumbnail: lessonItem?.thumbnail && isImage(lessonItem?.thumbnail) ? lessonItem?.thumbnail : null,
    contentUrl: lessonItem?.content_url,
    lesson_item_parent_guid: lessonItem?.lesson_item_parent_guid ? lessonItem?.lesson_item_parent_guid : lessonItem?.lesson_item_guid,
    attachments: lessonItem?.lesson_item_attachments ?? [],
  };
}

export function validateLessonItemsSection(section, client, isStudent) {
  if (section?.content_type) {
    return {
      ...validateLessonItemsItem(section),
      // name: '',
      guid: 'no-section',
    };
  }
  return {
    ...section,
    guid: client === CLIENT.SANTILLANA_DEMO && !section?.is_customized && isStudent ? 'editorial-section' : section?.lesson_item_guid,
    icon: !section?.is_customized,
  };
}
